export default "Here's an image from https://picsum.photos/.\n\n![Alternative text goes here](https://picsum.photos/600/200 \"Tooltip text goes here\")\n";